// extracted by mini-css-extract-plugin
module.exports = {"buttons":"PolicyChange_buttons__3uUzn","container":"PolicyChange_container__2F3Vt"};